import React from "react";
import Image from "next/image";

interface AboutSectionTwoMobileProps {
  title1: string;
  description1: string;
  title2: string;
  description2: string;
  title3: string;
  description3: string;
}

const AboutSectionTwoMobile = ({
  title1,
  description1,
  title2,
  description2,
  title3,
  description3
}: AboutSectionTwoMobileProps) => {
  return (
    <div className="container">
      <div className="-mx-4 flex flex-wrap">
        {/* Image first on mobile */}
        <div className="w-full px-4 mb-10">
          <div
            className="relative mx-auto aspect-[25/24] max-w-[350px] text-center"
            data-wow-delay=".15s"
          >
            <Image
              src="/images/about/about-image-2.png"
              alt="about image"
              fill
              className="drop-shadow-three dark:hidden dark:drop-shadow-none"
            />
            <Image
              src="/images/about/about-image-2-dark.png"
              alt="about image"
              fill
              className="hidden drop-shadow-three dark:block dark:drop-shadow-none"
            />
          </div>
        </div>
        
        {/* Content sections in smaller size */}
        <div className="w-full px-4">
          <div className="mx-auto max-w-full">
            <div className="mb-6">
              <h3 className="mb-3 text-lg font-bold text-black dark:text-white">
                {title1}
              </h3>
              <p className="text-sm font-medium leading-relaxed text-body-color">
                {description1}
              </p>
            </div>
            <div className="mb-6">
              <h3 className="mb-3 text-lg font-bold text-black dark:text-white">
                {title2}
              </h3>
              <p className="text-sm font-medium leading-relaxed text-body-color">
                {description2}
              </p>
            </div>
            <div className="mb-1">
              <h3 className="mb-3 text-lg font-bold text-black dark:text-white">
                {title3}
              </h3>
              <p className="text-sm font-medium leading-relaxed text-body-color">
                {description3}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AboutSectionTwoMobile; 